import { API_MAIN_VERSION, BASE_URL } from "@/config/constantes";
import { EMethod, IFactoryFunctionRequest } from "@bc-library/interface";
import { AxiosInstance } from "axios";
import useAxios from "../api/useAxios";

const resource = 'employeeWages'

type WagePageQuery = { page?: number; limit?: number; search?: string }

const getByYear = (axios: IFactoryFunctionRequest<any, any>) => (year: number, query: WagePageQuery = {}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/year/${year}`,
    query,
  })
}

const getAll = (axios: IFactoryFunctionRequest<any, any>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
  })
}

const createWage = (axios: IFactoryFunctionRequest<any, any>) => (data: any) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data,
  })
}

const updateWage = (axios: IFactoryFunctionRequest<any, any>) => (id: string, data: any) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
    data,
  })
}

const removeWage = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

const sendAccessCode = (axios: IFactoryFunctionRequest<any, any>) => (targetResourceId: string) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/access-code/send`,
    data: { targetResourceId },
  })
}

const getAccessAdmins = (axios: IFactoryFunctionRequest<any, any>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/access-code/admins`,
  })
}

const verifyAccessCode = (axios: IFactoryFunctionRequest<any, any>) => (code: string) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/access-code/verify`,
    data: { code },
  })
}

export default (axios: AxiosInstance) => ({
  getByYear: getByYear(useAxios(axios)),
  getAll: getAll(useAxios(axios)),
  create: createWage(useAxios(axios)),
  update: updateWage(useAxios(axios)),
  remove: removeWage(useAxios(axios)),
  sendAccessCode: sendAccessCode(useAxios(axios)),
  verifyAccessCode: verifyAccessCode(useAxios(axios)),
  getAccessAdmins: getAccessAdmins(useAxios(axios)),
})
